export default __webpack_public_path__ + "static/media/circle-checked.3df8680e.svg";